export default {
    line1: [{ required: true, message: Loc.g('Veuillez sélectionner une adresse valide'), trigger: 'blur' }],
    postalCode: [{ required: true, message: Loc.g('Veuillez sélectionner un code postal valide'), trigger: 'blur' }],
    city: [{ required: true, message: Loc.g('Veuillez sélectionner une ville valide'), trigger: 'blur' }],
    country: [{ required: true, message: Loc.g('Veuillez sélectionner un pays valide'), trigger: 'blur' }],
}
